export default __webpack_public_path__ + "static/media/Header01.e9c653bb.jpg";